<!-- Please don’t change these IDs because those are for automated testing: menuAdminDashboardLink, menuAdminMerchantLink, notificationViewAllLink, menuAdminStoreLink, menuAdminCouponLink, messageViewAllLink, searchMenuButton, message, notificationDropDownButton, userProfileDropdownDesktop, menuEditProfileLink, menuLogoutLink, menuAdminUserLink, menuAdminCommunityLink, menuAdminAnnouncementsLink, menuAdminProgramsLink, menuAdminChallengesLink, menuAdminAchievementsLink, menuAdminLocaleLink, menuAdminCustomFieldLink, menuAdminTeamLink, menuAdminPaymentLink, menuAdminSpecialLink, menuAdminReportLink, menuAdminReferralLink, menuAdminNotificationLink, menuAdminNotificationLink, menuAdminTrackerLink, menuAdminActivityLink, menuAdminUnitLink, menuAdminFoodLink, menuAdminReportAbuseLink, addmenu, menuAdminPostLink, merchantDashboardLink, searchMenuButton, message, notificationDropDownButton, messageViewAllLink, notificationViewAllLink, userProfileDropdownDesktop, menuEditProfileLink, menuLogoutLink -->
<header class="site__header " [ngClass]="{'no__login__header': userRole == -1,'wbx-admin-header-with-masquerade': showMasqueradeOffset }"
  [style.top.px]="showMasqueradeOffset ? 59 : null">
  <div class="row hdr__top">
    @if (userRole==-1 || userRole === userData.LOCALE_ADMIN) {
      <div class="logo">
        <a id="indexLink" href="#"><img src="/assets/images/logo.png" alt="logo" /></a>
      </div>
    }
    @if (userRole === userData.SUPER_ADMIN) {
      <div class="logo">
        <a id="dashboardLink" href="dashboard"><img src="/assets/images/logo.png" alt="logo" /></a>
      </div>
    }
    @if (userRole === userData.MERCHANT) {
      <div class="logo">
        <a id="merchantDashboardLink" href="merchant-dashboard"><img src="/assets/images/logo.png" alt="logo" /></a>
      </div>
    }
    <div class="hfr__top__left hide__mobileview" >
      @if (userRole === userData.SUPER_ADMIN) {
        <ul>
          <li class="dashboard_nav_icon" (click)="hideDropDownList()"><a id="menuAdminDashboardLink" href="javascript:void(0)" routerLink="/dashboard" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.DASHBOARD |translate}}</a></li>
          @if (userRole === userData.SUPER_ADMIN) {
            <li class="merchants_nav_icon" (click)="hideDropDownList()"><a  id="menuAdminMerchantLink" href="javascript:void(0)" routerLink="/merchant" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.MERCHANTS |translate}}</a></li>
          }
          <li class="stores_nav_icon" (click)="hideDropDownList()"><a id="menuAdminStoreLink" href="javascript:void(0)" routerLink="/admin-store" routerLinkActive="active" [class.storeActive]="isStoreMenuActive"><i></i>{{translations.GLOBAL.KEYS.STORES |translate}}</a></li>
          <li class="coupons_nav_icon" (click)="hideDropDownList()"><a id="menuAdminCouponLink" href="javascript:void(0)" routerLink="/coupon" routerLinkActive="active" [class.couponActive]="isCouponMenuActive"><i></i>{{translations.GLOBAL.KEYS.COUPONS |translate}}</a></li>
        </ul>
      }
    </div>
    @if (userRole==-1) {
      <div class="showmenu__icon">
        <a id="menu" (click)="mobRes()" href="javascript:void(0)"><img src="/assets/images/svg_icons/mobile_menu.svg" alt="icon" /></a>
      </div>
    }
    @if (userRole=== userData.SUPER_ADMIN || userRole === userData.MERCHANT || userRole === userData.LOCALE_ADMIN) {
      <div class="hdr__top__right">
        <ul>
          <!-- <li class="top__search__box dropdown" *ngIf="!(userRole === userData.LOCALE_ADMIN)">
          <a id="searchMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="/assets/images/svg_icons/header-search-gray-icon.svg" alt="icon" /></a>
          <div class="dropdown-menu open__search__box dropdown-outer" aria-labelledby="searchMenuButton">
            <input type="text" placeholder="Search here..." />
            <button><img src="/assets/images/svg_icons/search.svg" /></button>
          </div>
        </li> -->
        @if (!(userRole === userData.LOCALE_ADMIN)) {
          <li class="mail__search__box dropdown"  #messageDropdown>
            <a id="message" class="noti-count-show">
              @if (unreadMessageCounts > systemConstants.ZERO_DEFAULT) {
                <span >{{unreadMessageCounts}}</span>
              }
              <i [class.active]="isMessageMenuActive || notify" class="hdr-message-icon" (click)="getMessageCountAndList()"></i>
            </a>
            @if (notify) {
              <div class="dropdown-menu open__notification__box dropdown-outer show">
                @if (sAttributes.messageItems) {
                  <div class="notification-dropdown-in">
                    <!-- <b *ngIf="sAttributes.messageItems.length > 0">{{translations.GLOBAL.KEYS.YOU_HAVE | translate}}{{sAttributes.messageItems.length}}{{translations.GLOBAL.KEYS.NEW_MESSAGES | translate}}</b> -->
                    <ul class="new-message-drop-down">
                      @if (sAttributes.messageItems.length == 0) {
                        <li>{{translations.GLOBAL.KEYS.NO_NEW_MESSAGES | translate}}</li>
                      }
                      @for (notifyData of sAttributes.messageItems; track notifyData._id; let i = $index) {
                        <li>
                          <a href="javascript:void(0)">
                            <div class="noti-img">
                              <app-cdn-image-loader
                                [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                                [src]="isUserContactRow(notifyData)? '': notifyData?.counterUserData?.profileData?.image"
                                [height]= "80"
                                [width]= "80">
                              </app-cdn-image-loader>
                            </div>
                            <div class="noti-content">
                              <h3 class="clearfix">{{isUserContactRow(notifyData)? notifyData?.name: notifyData?.counterUserData?.username}} <strong>{{notifyData.createdDate | dateToMinutes}}</strong></h3>
                              <p>
                            @if (isUserContactRow(notifyData)) {
                               {{ notifyData?.email }} — {{ notifyData?.message | truncate:['60', '...'] }}
                            } @else {
                               {{ notifyData?.counterMessage | truncate:['60', '...'] }}
                            }
                               </p>

                            </div>
                          </a>
                        </li>
                      }
                    </ul>
                    @if (sAttributes.messageItems.length > 0) {
                      <div class="view-all">
                        <a id="messageViewAllLink" href="javascript:void(0)" routerLink="/message" (click)="notify = !notify">{{translations.GLOBAL.KEYS.VIEW_ALL |translate}}</a>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </li>
        }
        @if (!(userRole === userData.LOCALE_ADMIN)) {
          <li class="notification__search__box dropdown"  (click)="getUnreadNotificationCountAndList()" #notificationDropdown>
            <a id="notificationDropDownButton" class="noti-count-show" href="javascript:void(0)" (click)="setNotificationDropdownState(!inotify)">
              @if (unreadNotificationCounts > 0) {
                <span >{{unreadNotificationCounts}}</span>
              }
              <i [class.active]="isNotificationMenuActive || inotify" class="hdr-notification-icon"></i>
            </a>
            @if (inotify) {
              <div class="dropdown-menu open__notification__box dropdown-outer">
                <div class="notification-dropdown-in">
                  <div class="hdr__notification">
                    <div class="hdr_noti_top">
                      <strong>{{translations.GLOBAL.KEYS.NOTIFICATIONS |translate}}</strong>
                      <a  id="notificationViewAllLink" routerLink="notification" (click)="setNotificationDropdownState(false)">{{translations.GLOBAL.KEYS.VIEW_ALL |translate}}</a>
                    </div>
                    <div class="hdr_noti_list">
                      <ng-scrollbar class="notification-scrollbar-custom-height wbx-user-scrollbar" [config]="{ suppressScrollX: true ,wheelPropagation: false}">
                        @for (notificationData of notificationList; track notificationData; let i = $index) {
                          <div>
                            @if (notificationData.message) {
                              <div class="hdr_noti_row" [ngClass]="{'new_noti': notificationData.status === showNotificationStatus}"  (click)="handleNotificationClick(notificationData)">
                                <div class="hdr_noti_user_img">
                                  <app-cdn-image-loader
                                    [defaultImage]="'/assets/images/wellbux-default-img/default-user.svg'"
                                    [isCdnImage]="notificationData.isAnnouncement ? false : isImageCdnByImageType(notificationData.media.imageType)"
                                    [src]="notificationData.isAnnouncement ? '/assets/images/wellbux-default-img/default-announcement.svg' : getImageSrcByImageType(notificationData.media)"
                                    [height]="80"
                                    [width]="80">
                                  </app-cdn-image-loader>
                                </div>
                                <div class="hdr_noti_user_txt">
                                  <p [innerHTML]="notificationData.message" [style.font-weight]="notificationData.isNotificationRead ? 'normal' : 'bold'"></p>
                                  <span>{{notificationData.createdDate | dateToMinutes}}</span>
                                </div>
                                <div class="hdr_noti_img" hidden>
                                  <img src="/assets/images/wellbux-default-img/default-user.svg" alt="" />
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </ng-scrollbar>
                    </div>
                  </div>
                </div>
              </div>
            }
          </li>
        }
        <li class="nav__icon">
          <a id="menu" (click)="mobRes()" href="javascript:void(0)">
            <img src="/assets/images/svg_icons/mobile_menu.svg" alt="icon" />
          </a>
        </li>
        <li class="user__top_info dropdown" dropdown #profileInfoDropdown>
          <a id="userProfileDropdownDesktop" href="javascript:void(0)" (click)="profileInfoShow = !profileInfoShow">
            <div class="dropdown-toggle">
              @if (loginUser && loginUser.profileData && !userProfileImgage; as isCdnImage) {
                <span class="pImg">
                  <app-cdn-image-loader
                    [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                    [isCdnImage]="isImageCdnByImageType(loginUser.profileData.imageType)"
                    [src]="getImageSrcByImageType(loginUser.profileData)"
                    [height]="200"
                    [width]="200">
                  </app-cdn-image-loader>
                </span>
              }
              @if (loginUser && loginUser.profileData && userProfileImgage; as isCdnImage) {
                <span class="pUpdateImg">
                  <app-cdn-image-loader
                    [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                    [src]="userProfileImgage"
                    [height]="200"
                    [width]="200">
                  </app-cdn-image-loader>
                </span>
                } {{loginUser.fname}}
              </div>
            </a>
            @if (profileInfoShow) {
              <div class="user__top_in">
                <div class="user__top_box">
                  <a id="menuEditProfileLink" href="javascript:void(0)" (click)="hideDropDownList()" routerLink="/edit-profile">{{translations.GLOBAL.KEYS.EDIT_PROFILE |translate}}</a>
                  <a id="menuLogoutLink" (click)="logout()" href="javascript:void(0)">{{translations.GLOBAL.KEYS.LOGOUT |translate}}</a>
                </div>
              </div>
            }
          </li>
        </ul>
      </div>
    }
    @if (userRole==-1) {
      <div #target class="hdr__top__right" id="clickmenu" [ngClass]="{'menu-slide': isMobileNavVisible}">
        @if (userRole==-1) {
          <div class="closemenu__icon">
            <a id="menu" (click)="mobRes()" href="javascript:void(0)"><img src="/assets/images/svg_icons/nav-close-icon.svg" alt="icon" /></a>
          </div>
        }
        <div class="inner-mobile-nav-bg">
          <ul >
            @if (isSectionItems) {
              <li class="section-item">
                @for (sectionDetailsList of sectionDetailsList | keyvalue; track sectionDetailsList; let index = $index) {
                  <span>
                    <a id="menu{{sectionDetailsList.value.id}}Link" pageScroll href="javascript:void(0)" (click)="scrollTo(sectionDetailsList.value.id, index)"  [ngClass]="{'active': this.sectionIndex === index}">
                      {{sectionDetailsList.value.label | translate}}
                    </a>
                  </span>
                }
              </li>
            }
            @if (!isSectionItems) {
              <li class="section-item">
                @for (sectionDetailsList of sectionDetailsList | keyvalue; track sectionDetailsList; let index = $index) {
                  <span>
                    <a id="menu{{sectionDetailsList.value.id}}Link" pageScroll href="#{{sectionDetailsList.value.id}}" (click)="scrollTo(sectionDetailsList.value.id, index)"  [ngClass]="{'active': this.sectionIndex === index}">
                      {{sectionDetailsList.value.label | translate}}
                    </a>
                  </span>
                }
              </li>
            }
            <li><a id="menuContactLink" href="javascript:void(0)" class="open-details-btn" routerLink="/contact-us" routerLinkActive="active">{{translations.GLOBAL.KEYS.CONTACT_US |translate}}</a> </li>
             <li class="wbx-dropdown signup-dropdown" (mouseenter)="isSignupDropdownOpen = true" (mouseleave)="isSignupDropdownOpen = false">
               <a
                id="menuSignUpLink"
                class="wbx-dropdown-toggle"
                href="javascript:void(0)"
                [ngClass]="{ 'active': isSignupDropdownOpen }">
                {{translations.GLOBAL.KEYS.SIGN_UP | translate}}
              </a>
             <div class="wbx-dropdown-outer" *ngIf="isSignupDropdownOpen">
  <div class="wbx-dropdown-inner">

    <!-- USER SIGNUP -->
    <div class="signup-dropdown-inner-item">
      <a
        href="javascript:void(0)"
        class="open-details-btn wbx-user-signup-btn"
        id="hdrUserSignupMenu"
        routerLink="/user-signup"
        routerLinkActive="active"
        (click)="isSignupDropdownOpen = false">
        <i></i>
        <div class="signup-dropdown-inner-item-content">
          <strong>{{translations.GLOBAL.KEYS.USER_SIGNUP_BUTTON | translate}}</strong>
          <p>{{translations.GLOBAL.KEYS.USER_SIGNUP_SUB_TEXT | translate}}</p>
        </div>
      </a>
    </div>

    <!-- MERCHANT SIGNUP -->
    <div class="signup-dropdown-inner-item">
      <a
        href="javascript:void(0)"
        class="open-details-btn wbx-merchant-signup-btn"
        id="hdrMerchantSignupMenu"
        routerLink="/merchant-signup"
        routerLinkActive="active"
        (click)="isSignupDropdownOpen = false">
        <i></i>
        <div class="signup-dropdown-inner-item-content">
          <strong>{{translations.GLOBAL.KEYS.MERCHANT_SIGNUP_BUTTON | translate}}</strong>
          <p>{{translations.GLOBAL.KEYS.MERCHANT_SIGNUP_SUB_TEXT | translate}}</p>
        </div>
      </a>
    </div>
  </div>
</div>
            </li>
           <li>
								<!-- <a href="javascript:void(0)" id="hdrLoginMenu" class="open-details-btn active"  (click)="openLogin() " data-target="login-details-section"> -->
                  	<a href="javascript:void(0)" id="hdrLoginMenu" class="open-details-btn" routerLink="/login" routerLinkActive="active" data-target="login-details-section">
									{{translations.GLOBAL.KEYS.LOGIN | translate}}
								</a>
							</li>
          </ul>
        </div>
      </div>
    }
  </div>
  @if (userRole === userData.SUPER_ADMIN || userRole === userData.MERCHANT || userRole === userData.LOCALE_ADMIN) {
    <div class="header-nav" id="clickmenu" [ngClass]="{'menu-slide': isMobileNavVisible}">
      <div class="closemenu__icon">
        <a id="menu" (click)="mobRes()" href="javascript:void(0)"><img src="/assets/images/svg_icons/nav-close-icon.svg" alt="icon" /></a>
      </div>
      <div class="inner-mobile-nav-bg">
        <div class="mob__user__top_info dropdown" dropdown>
          <div id="dropdownMenuButton" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-basic">
            <a href="javascript:void(0)" (click)="mobRes()">
              @if (loginUser && loginUser.profileData && !userProfileImgage; as isCdnImage) {
                <span class="pImg">
                  <app-cdn-image-loader
                    [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                    [isCdnImage]="isImageCdnByImageType(loginUser.profileData.imageType)"
                    [src]="getImageSrcByImageType(loginUser.profileData)"
                    [height]="200"
                    [width]="200">
                  </app-cdn-image-loader>
                </span>
              }
              @if (loginUser && loginUser.profileData && userProfileImgage) {
                <span class="pUpdateImg">
                  <app-cdn-image-loader
                    [defaultImage]="'/assets/images/wellbux-default-img/default-merchant.svg'"
                    [src]="userProfileImgage"
                    [height]="200"
                    [width]="200">
                  </app-cdn-image-loader>
                </span>
                } {{loginUser.fname}}
              </a>
            </div>
            <div class="profile__mobile dropdown-menu" *dropdownMenu>
              <a (click)="mobRes()" href="javascript:void(0)" routerLink="/edit-profile">{{translations.GLOBAL.KEYS.EDIT_PROFILE | translate}}</a>
              <a (click)="logout()" href="javascript:void(0)">{{translations.GLOBAL.KEYS.LOGOUT |translate}}</a>
            </div>
          </div>
          <ul class="show__mobileview" >
            <!-- For Merchant Menu Start -->
            @if (userRole === userData.MERCHANT) {
              <li class="dashboard_nav_icon"><a (click)="mobRes()" routerLink="/merchant-dashboard" routerLinkActive="active" href="javascript:void(0)"><i></i>{{translations.GLOBAL.KEYS.DASHBOARD | translate}}</a></li>
            }
            @if (userRole === userData.MERCHANT) {
              <li class="stores_nav_icon"><a (click)="mobRes()" href="javascript:void(0)" routerLink="/admin-store" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.MY_STORE |translate}}</a></li>
            }
            @if (userRole === userData.MERCHANT) {
              <li class="payments_nav_icon"><a (click)="mobRes()" href="javascript:void(0)" routerLink="/merchant-payment" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PAYMENT | translate}}</a></li>
            }
            @if (userRole === userData.MERCHANT) {
              <li class="coupons_nav_icon"><a (click)="mobRes()" href="javascript:void(0)" routerLink="/coupon" routerLinkActive="active" [class.active]="isCouponMenuActive"><i></i>{{translations.GLOBAL.KEYS.COUPONS |translate}}</a></li>
            }
            @if (userRole === userData.MERCHANT) {
              <li class="specialsales_nav_icon"><a (click)="mobRes()" href="javascript:void(0)" routerLink="/participated-in-sale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PARTICIPATE_IN_SALES | translate}}</a></li>
            }
            <!-- For Merchant Menu End -->
            <!-- For Admin Menu Start -->
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="dashboard_nav_icon "><a (click)="mobRes()" routerLink="/dashboard" routerLinkActive="active" href="javascript:void(0)"><i></i>{{translations.GLOBAL.KEYS.DASHBOARD | translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="merchants_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/merchant" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.MERCHANTS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="stores_nav_icon"><a (click)="mobRes()" routerLink="/admin-store" routerLinkActive="active" href="javascript:void(0)" [class.active]="isStoreMenuActive"><i></i>{{translations.GLOBAL.KEYS.STORES |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="coupons_nav_icon "><a (click)="mobRes()" routerLink="/coupon" routerLinkActive="active" href="javascript:void(0)" [class.couponActive]="isCouponMenuActive"><i></i>{{translations.GLOBAL.KEYS.COUPONS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="users_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/admin-user" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.USERS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="communities_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/admin-community" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.COMMUNITIES |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="announcements_nav_icon" ><a href="javascript:void(0)" (click)="mobRes()" routerLink="/announcement" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.ANNOUNCEMENTS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="programs_nav_icon"><a class="main-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-program" routerLinkActive="active" [class.active]="isProgramsMenuActive"><i></i>{{translations.GLOBAL.KEYS.PROGRAMS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="challenges_nav_icon"><a class="sub-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-program/challenges" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.CHALLENGES |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="achievement_nav_icon"><a class="sub-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-program/achievements" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.ACHIEVEMENTS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="wellness_nav_icon "><a class="sub-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-program/wellness" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.WELLNESS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="locale_nav_icon" [class.active]="isLocaleMenuActive"><a class="main-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/locale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.LOCALE |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="customfield_nav_icon"><a class="sub-drop-item" href="javascript:void(0)" (click)="mobRes()" routerLink="/custom-field/" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.CUSTOM_FIELDS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="teams_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/team" routerLinkActive="active"><i></i> {{translations.GLOBAL.KEYS.TEAMS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="payments_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/admin-payment" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PAYMENT |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="specialsales_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/special-sale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.SPECIAL_SALES |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="reports_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/report-dashboard" routerLinkActive="active" [class.active]="isReportMenuActive"><i></i>{{translations.GLOBAL.KEYS.REPORTS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="referral_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-referral" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.REFERRAL |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="notification_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-notification" routerLinkActive="active" ><i></i>{{translations.GLOBAL.KEYS.NOTIFICATIONS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
              <li class="tracker_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-tracker" routerLinkActive="active" [class.active]="isTrackerMenuActive"><i></i>{{translations.GLOBAL.KEYS.TRACKERS |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="unit_nav_icon" [class.active]="isUnitMenuActive"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-unit" routerLinkActive="active" ><i></i> {{translations.GOAL_ADD_EDIT_FORM.UNIT |translate}} </a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="activities_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-activities" routerLinkActive="active"><i></i> {{translations.GLOBAL.KEYS.ACTIVITIES |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="food_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-food" routerLinkActive="active"><i></i> {{translations.GLOBAL.KEYS.FOOD |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="report-abuse_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-report-abuse" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.REPORTED_ABUSE |translate}}</a></li>
            }
            @if (userRole === userData.SUPER_ADMIN) {
              <li class="post_nav_icon"><a href="javascript:void(0)" (click)="mobRes()" routerLink="/manage-post" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.POST |translate}}</a></li>
            }
            <!-- For Admin Menu Start -->
          </ul>
        </div>
        <ul id="teleporter">
          <!-- For Merchant Menu Start -->
          @if (userRole === userData.MERCHANT) {
            <li class="dashboard_nav_icon "><a id="menuMerchantDashboardLink" href="javascript:void(0)" (click)="mobRes()" routerLink="/merchant-dashboard" routerLinkActive="active" href="javascript:void(0)"><i></i>{{translations.GLOBAL.KEYS.DASHBOARD | translate}}</a></li>
          }
          @if (userRole === userData.MERCHANT) {
            <li class="stores_nav_icon"><a id="menuMerchantStoreLink" href="javascript:void(0)" routerLink="/admin-store" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.MY_STORE_MY_LOCATION |translate}}</a></li>
          }
          @if (userRole === userData.MERCHANT) {
            <li class="payments_nav_icon"><a id="menuMerchantPaymentLink" href="javascript:void(0)" routerLink="/merchant-payment" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PAYMENT |translate}}</a></li>
          }
          @if (userRole === userData.MERCHANT) {
            <li class="coupons_nav_icon"><a id="menuMerchantCouponLink" href="javascript:void(0)" routerLink="/coupon" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.COUPONS |translate}}</a></li>
          }
          @if (userRole === userData.MERCHANT) {
            <li class="specialsales_nav_icon"><a id="menuMerchantSpecialSalesLink" href="javascript:void(0)" routerLink="/participated-in-sale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PARTICIPATE_IN_SALES | translate}}</a></li>
          }
          <!-- For Merchant Menu End -->
          <!-- For Admin Menu Start -->
          @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
            <li class="users_nav_icon" (click)="hideDropDownList()"><a id="menuAdminUserLink" href="javascript:void(0)" routerLink="/admin-user" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.USERS |translate}}</a></li>
          }
          @if (userRole === userData.SUPER_ADMIN) {
            <li class="communities_nav_icon" (click)="hideDropDownList()"><a id="menuAdminCommunityLink" href="javascript:void(0)" routerLink="/admin-community" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.COMMUNITIES |translate}}</a></li>
          }
          @if (userRole === userData.SUPER_ADMIN) {
            <li class="announcements_nav_icon" (click)="hideDropDownList()"><a id="menuAdminAnnouncementsLink" href="javascript:void(0)" routerLink="/announcement" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.ANNOUNCEMENTS |translate}}</a></li>
          }
          @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
            <li class="programs_nav_icon dropdownmenu" (click)="hideDropDownList()"> <a id="menuAdminProgramsLink" class="arrow" href="javascript:void(0)" routerLink="/manage-program" routerLinkActive="active"  [class.active]="isProgramsMenuActive"><i></i>{{translations.GLOBAL.KEYS.PROGRAMS |translate}}</a>
            <div class="show-dropdownmenu">
              <ul>
                @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
                  <li class="challenges_nav_icon" (click)="hideDropDownList()"> <a id="menuAdminChallengesLink" href="javascript:void(0)" routerLink="/manage-program/challenges" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.CHALLENGES |translate}}</a> </li>
                }
                @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
                  <li class="achievement_nav_icon" (click)="hideDropDownList()"> <a id="menuAdminAchievementsLink" href="javascript:void(0)" routerLink="/manage-program/achievements" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.ACHIEVEMENTS |translate}}</a> </li>
                }
                @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
                  <li class="wellness_nav_icon" (click)="hideDropDownList()"> <a id="menuAdminAchievementsLink" href="javascript:void(0)" routerLink="/manage-program/wellness" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.WELLNESS |translate}}</a> </li>
                }
              </ul>
            </div>
          </li>
        }
        @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
          <li class="locale_nav_icon" [ngClass]="userRole !== userData.LOCALE_ADMIN ? 'dropdownmenu' : 'li-text-center'" (click)="hideDropDownList()" [class.active]="isLocaleMenuActive"> <a id="menuAdminLocaleLink" class="arrow" href="javascript:void(0)" routerLink="/locale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.LOCALE |translate}}</a>
          <div class="show-dropdownmenu">
            <ul>
              @if (userRole === userData.SUPER_ADMIN) {
                <li class="customfield_nav_icon" (click)="hideDropDownList()"><a id="menuAdminCustomFieldLink" href="javascript:void(0)" routerLink="/custom-field/" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.CUSTOM_FIELDS |translate}}</a></li>
              }
            </ul>
          </div>
        </li>
      }
      @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
        <li class="teams_nav_icon" (click)="hideDropDownList()"><a id="menuAdminTeamLink" href="javascript:void(0)" routerLink="/team" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.TEAMS |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="payments_nav_icon" (click)="hideDropDownList()"><a id="menuAdminPaymentLink" href="javascript:void(0)" routerLink="/admin-payment" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.PAYMENT |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="specialsales_nav_icon" (click)="hideDropDownList()"><a id="menuAdminSpecialLink" href="javascript:void(0)" routerLink="/special-sale" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.SPECIAL_SALES |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
        <li class="reports_nav_icon" (click)="hideDropDownList()"><a id="menuAdminReportLink" href="javascript:void(0)" routerLink="/report-dashboard" routerLinkActive="active" [class.active]="isReportMenuActive"><i></i>{{translations.GLOBAL.KEYS.REPORTS |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="referral_nav_icon" (click)="hideDropDownList()"><a id="menuAdminReferralLink" href="javascript:void(0)" routerLink="/manage-referral" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.REFERRAL |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="notification_nav_icon" (click)="hideDropDownList()"><a id="menuAdminNotificationLink" href="javascript:void(0)" routerLink="/manage-notification" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.NOTIFICATIONS |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN || userRole === userData.LOCALE_ADMIN) {
        <li class="tracker_nav_icon" (click)="hideDropDownList()"><a id="menuAdminTrackerLink" href="javascript:void(0)" routerLink="/manage-tracker" routerLinkActive="active" [class.active]="isTrackerMenuActive"><i></i>{{translations.GLOBAL.KEYS.TRACKERS |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="activities_nav_icon" (click)="hideDropDownList()"><a id="menuAdminActivityLink" href="javascript:void(0)" routerLink="/manage-activities" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.ACTIVITIES |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="unit_nav_icon" (click)="hideDropDownList()" [class.active]="isUnitMenuActive"><a id="menuAdminUnitLink" href="javascript:void(0)" routerLink="/manage-unit" routerLinkActive="active" ><i></i>{{translations.GOAL_ADD_EDIT_FORM.UNITS |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="food_nav_icon" (click)="hideDropDownList()"><a id="menuAdminFoodLink" href="javascript:void(0)"  routerLink="/manage-food" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.FOOD |translate}}</a></li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="report-abuse_nav_icon" (click)="hideDropDownList()"> <a id="menuAdminReportAbuseLink" href="javascript:void(0)" routerLink="/manage-report-abuse" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.REPORTED_ABUSE |translate}}</a> </li>
      }
      @if (userRole === userData.SUPER_ADMIN) {
        <li class="post_nav_icon" (click)="hideDropDownList()"><a id="menuAdminPostLink" href="javascript:void(0)"  routerLink="/manage-post" routerLinkActive="active"><i></i>{{translations.GLOBAL.KEYS.POSTS |translate}}</a></li>
      }
      <!-- For Admin Menu End -->
    </ul>
    <div class="hdr__added__menu" #dropdownMenu>
      <div class="hdr__added__menu__top d-none" id="addmenu" (click)="showHideMoreMenu = !showHideMoreMenu"><i class="fas fa-ellipsis-h"></i><span>{{translations.GLOBAL.KEYS.MORE |translate}} <b class="fas fa-chevron-down"></b></span> </div>
      <ul id="receiver" [class.showIcon]="showHideMoreMenu" (click)="handleItemClick($event)"></ul>
    </div>
  </div>
}
</header>


